import { CreditFacilityEventLayout } from "features/credit-facility/CreditFacilityEventLayout";
import { CreditFacilityPrincipalUsesTable } from "features/credit-facility/CreditFacilityPrincipalUsesTable";
import { CreditFacilityReallocationSummaryTable } from "features/credit-facility/reallocation/CreditFacilityReallocationSummaryTable";
import { useFundFamilyEventRetrieveSuspense } from "gen/endpoints/fund-family-event/fund-family-event";
import { FundFamilyEventSubTypeEnum } from "gen/model/fundFamilyEventSubTypeEnum";
import { PermissionTypeEnum } from "gen/model/permissionTypeEnum";
import { useTranslation } from "react-i18next";
import { PageWizardFormFooter } from "shared/components/layout/PageWizard";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

export const CreditFacilitySummary: React.FC = () => {
  const { fundFamilyId, fundFamilyEventId } = useRequiredStringParams();
  const { data: fundFamilyEvent } = useFundFamilyEventRetrieveSuspense(
    fundFamilyId,
    fundFamilyEventId,
  );
  const { t } = useTranslation(["creditFacility", "enums"]);
  return (
    <CreditFacilityEventLayout canEditEvent={false}>
      {fundFamilyEvent.sub_type == FundFamilyEventSubTypeEnum.reallocation ? (
        <CreditFacilityReallocationSummaryTable />
      ) : (
        <CreditFacilityPrincipalUsesTable
          fundFamilyEventId={fundFamilyEventId}
          title={t("creditFacility:event_summary", {
            eventType: t(
              `enums:FundFamilyEventSubTypeEnum.${fundFamilyEvent.sub_type!}`,
            ),
          })}
          eventType={fundFamilyEvent.sub_type}
        />
      )}
      <PageWizardFormFooter submitPermission={PermissionTypeEnum.approve} />
    </CreditFacilityEventLayout>
  );
};
